import React, { useState } from 'react';
import { X, Sparkles } from 'lucide-react';

const STORAGE_KEY = 'go4nihongo_redesign_banner_v1';

export default function RedesignBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem(STORAGE_KEY));

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] flex justify-center px-3 pb-3"
      style={{ pointerEvents: 'none' }}
    >
      <div
        className="relative w-full max-w-xl rounded-2xl overflow-hidden"
        style={{
          background: 'var(--bg-primary)',
          boxShadow: 'var(--neu-out)',
          pointerEvents: 'auto',
        }}
      >
        {/* accent stripe */}
        <div className="h-[3px] w-full" style={{ background: 'var(--accent)' }} />

        <div className="flex items-start gap-3 px-4 py-3">
          {/* icon */}
          <div
            className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0 mt-0.5"
            style={{ background: 'var(--bg-primary)', boxShadow: 'var(--neu-in-sm)' }}
          >
            <Sparkles size={16} style={{ color: 'var(--accent)' }} />
          </div>

          {/* text */}
          <div className="flex-1 min-w-0">
            <p className="text-sm font-black mb-0.5" style={{ color: 'var(--text-primary)' }}>
              Fresh new look!
            </p>
            <p className="text-xs leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
              GO4NIHONGO just got a full redesign. We'd love your feedback — any suggestions or issues?{' '}
              <a
                href="/contact"
                onClick={dismiss}
                className="font-black underline underline-offset-2 transition-opacity hover:opacity-70"
                style={{ color: 'var(--accent)' }}
              >
                Contact us
              </a>
            </p>
          </div>

          {/* close */}
          <button
            onClick={dismiss}
            className="shrink-0 w-7 h-7 rounded-lg flex items-center justify-center transition-all active:scale-90"
            style={{
              background: 'var(--bg-primary)',
              boxShadow: 'var(--neu-out-sm)',
              color: 'var(--text-muted)',
            }}
            aria-label="Dismiss"
          >
            <X size={13} />
          </button>
        </div>
      </div>
    </div>
  );
}
